module.exports = __webpack_public_path__ + "img/애고미_이모티콘-22.1163d40.png";